;(function () {
  'use strict'
  /**
   * Invoice Module
   *
   */

  const _openInvoiceModal = function (modal_type, $modal, $scope) {
    $modal({
      template: `/r/static/templates/invoices/${modal_type}-modal.html`,
      persist: true,
      show: true,
      backdrop: 'static',
      scope: $scope,
    }).then(function () {
      // $timeout(function () {
      //   $('#' + template + '-' + id).focus()
      // }, 700)
    })
  }

  // this is here because it is called from a few different views
  function openCreditReceiptModal(iinumber, Invoice, $modal, $scope) {
    Invoice.getCreditInvoice(
      {iinumber},
      // success handler
      function (data) {
        $scope.modal_data = {
          credit_invoice: data,
          organization_name: $scope.settings.name_,
        }
      },
    )
    _openInvoiceModal('credit-receipt', $modal, $scope)
  }

  // NB! These percentages are also in report.py but note that we cannot remove
  // percentages from there because of existing invoices.
  var SUPPORTED_VAT_PERCENTAGES = [
    {label: '0 %', value: 0},
    {label: '10 %', value: 10},
    {label: '13,5 %', value: 13.5},
    {label: '25,5 %', value: 25.5},
  ]

  angular
    .module('invoices', ['ngResource', 'settings', 'ngRoute'])
    .config(['$routeProvider', function ($routeProvider) {
      $routeProvider
        .when(CONFIG.url.invoices.all(), {
          controller: 'InvoiceCtrl',
          templateUrl: '/r/static/templates/invoices/list.html',
        })
        .when(CONFIG.url.invoices.report(), {
          controller: 'InvoiceReportCtrl',
          templateUrl: '/r/static/templates/invoices/report.html',
          reloadOnSearch: false,
        })
        .when(CONFIG.url.invoices.sales_invoice_list(), {
          controller: 'SalesInvoiceListCtrl',
          templateUrl: '/r/static/templates/invoices/sales-invoice-list.html',
          reloadOnSearch: false,
        })
        .when(CONFIG.url.invoices.accounts_receivable(), {
          controller: 'AccountsReceivableCtrl',
          templateUrl: '/r/static/templates/invoices/accounts-receivable.html',
          reloadOnSearch: false,
        })
        .when(CONFIG.url.invoices.create(), {
          controller: 'InvoiceAddCtrl',
          templateUrl: '/r/static/templates/invoices/new.html',
        })
        .when(CONFIG.url.invoices.view(), {
          controller: 'InvoiceEditCtrl',
          templateUrl: '/r/static/templates/invoices/single.html',
        })
        .when(CONFIG.url.invoices.view_one(), {
          controller: 'InvoiceEditCtrl',
          templateUrl: '/r/static/templates/invoices/single.html',
        })
        .when(CONFIG.url.invoices.reminder(), {
          controller: 'InvoiceAddCtrl',
          templateUrl: '/r/static/templates/invoices/new.html',
          reminder: true,
        })
        .when(CONFIG.url.invoices.addrecips(), {
          controller: 'InvoiceAddCtrl',
          templateUrl: '/r/static/templates/invoices/new.html',
          addrecips: true,
        })
    }])
    .factory('Invoice', ['$resource', function ($resource) {
      var I = $resource(
        CONFIG.api('invoices'),
        {},
        {
          updateStatusLegacy: {method: 'POST', params: {id: 'update_status_legacy'}},
          addAction: {method: 'POST', params: {id: 'add_action'}},
          getInstanceEventsLegacy: {method: 'POST', params: {id: 'get_invoice_instance_actions_legacy'}},
          getInstanceEvents: {method: 'POST', params: {id: 'get_invoice_instance_actions'}},
          query: {method: 'GET', isArray: false},
          supersearch: {method: 'POST', isArray: false, params: {id: 'supersearch'}},
          preview: {method: 'POST', params: {id: 'preview'}},
          report: {method: 'POST', isArray: false, params: {id: 'report'}},
          sales_invoice_list: {method: 'POST', isArray: false, params: {id: 'sales_invoice_list'}},
          accounts_receivable: {method: 'POST', isArray: false, params: {id: 'accounts_receivable'}},
          addFakeBankRow: {method: 'POST', params: {id: 'add_fake_bank_row'}},
          getCreditInvoice: {method: 'POST', params: {id: 'get_credit_invoice'}},
        },
      )
      return I
    }])

  /* Controllers */

  angular
    .module('invoices')
    .controller('InvoiceCtrl', ['$scope', 'Invoice', '$location', '$timeout', '$rootScope', '$compile', function ($scope, Invoice, $location, $timeout, $rootScope, $compile) {
      if ($location.path() === CONFIG.url.invoices.all()) {
        $scope.utils.setPageTitle(_('invoice_sent_invoices'))
        $scope.utils.setPageID('invoices')
      }

      $scope.paid_percents = []

      getInvoices()

      $scope.paginate = function (page) {
        $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
      }

      // NB: Almost duplicate in announcements.js / membercards.js
      if ($location.hash().match(/receipt-notify\?n=(\d+)&type=(\w+)/)) {
        const msgCount = RegExp.$1
        const msgType = RegExp.$2
        $rootScope.notification = $compile(
          '<span>' +
            _('HTML_notification_mooney_invoice_' + (msgType == 'pdf' ? 'created' : 'sent') + '_paid', {
              _n: msgCount,
              url: CONFIG.url.log.receipts(),
            }) +
            '<br>' +
            (msgType == 'pdf' ? '' : _('HTML_notification_invoice_addrecips_note')) +
            '</span>',
        )($scope)
      }

      function getInvoices() {
        Invoice.query(
          {
            id: 'all',
            dashboard: $location.path() !== CONFIG.url.invoices.all(),
          },
          // success handler
          function (data) {
            $scope.invoices = data.invoices
            $rootScope.invoice_dashboard_ok = true

            // pagination
            $scope.pageSize = 20
            $scope.numberOfPages = Math.ceil($scope.invoices.length / $scope.pageSize)
            $scope.currentPage = 0

            a4.loaded($scope)
            // var interval = 60000;

            // if($location.path() == CONFIG.url.invoices.all()) {
            //   $.each(data.stats.count_queued, function(val) {
            //     interval = data.stats.count_queued[val] > 0 ? 5000 : Math.min(interval, 60000);
            //   });
            //   a4.timeout($timeout, $scope, getInvoices, interval);
            // }

            // For the fancy loading animation
            a4.timeout(
              $timeout,
              $scope,
              function () {
                $.each($scope.invoices, function (n, i) {
                  $scope.paid_percents[i.id] = Math.round(
                    ((i.count_total_c - i.count_open_c - i.count_overdue_c) / i.count_total_c) * 100,
                  )
                })
              },
              200,
            )
          },
          // error handler
          a4.restErrorFactory($scope),
        )
      }
    }])

  angular.module('invoices').controller('InvoiceReportCtrl', ['$scope', '$routeParams', '$location', 'Invoice', function ($scope, $routeParams, $location, Invoice) {
    $scope.utils.setPageID('invoices')
    $scope.utils.setPageTitle(_('invoice_sync_reports'))
    $scope.reportView = 'banksync'

    var now = new Date()
    var currYear = now.getFullYear()
    var currMonth = now.getMonth() + 1
    $scope.criteria = {
      // period:     $routeParams.period     || '' + currYear,
      from: $routeParams.from || '' + currYear + '-01-01',
      to: $routeParams.to || '' + currYear + '-12-31',
      invoice_id: $routeParams.invoice_id ? $routeParams.invoice_id.split(',') : ['all'],
    }

    $scope.ref_periods = []
    for (var y = 2016; y <= currYear; y++) {
      for (var m = 1; m <= 12; m++) {
        if (y === currYear && m > currMonth) break
        $scope.ref_periods.unshift({label: m + '/' + y, value: y + '-' + ('00' + String(m)).substr(String(m).length)})
      }
    }

    $scope.invoices = []
    Invoice.query(
      {
        id: 'all',
        dashboard: false,
      },
      // success handler
      function (data) {
        $scope.invoices = [{id: 'all', subject: _h('invoice_report_all_invoices')}]

        data.invoices.forEach(function (i) {
          $scope.invoices.push({
            id: '' + i.id,
            //' <small style="float:right" class="muted"> ' + i.amount + ' €' +
            //' <small style="float:right" class="muted"> ' + i.count_paid_c + '/' + i.count_total_c + ' ' + _h('invoice_report_paid') +
            subject:
              ' <small style="float:right" class="muted"> ' +
              _h('invoice_report_paid', {m: i.count_paid_c, n: i.count_total_c}) +
              '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>' +
              _h('invoice_report_filter_invoice') +
              ' <b>' +
              a4.esc(i.subject) +
              '</b><small>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>',
          })
        })
        a4.loaded($scope)
      },
      // error handler
      a4.restErrorFactory($scope),
    )

    var request = 0
    $scope.loadReport = function () {
      var allIndex = $scope.criteria.invoice_id.indexOf('all')
      if (allIndex >= 0 && $scope.criteria.invoice_id.length > 1) {
        if ($location.search().invoice_id === 'all') {
          // remove "all items" entry if something else is selected (and "all" was previously selected)
          $scope.criteria.invoice_id.splice(allIndex, 1)
        } else {
          // remove invoice id entries if "all" is selected (and it wasn't previously selected)
          $scope.criteria.invoice_id = ['all']
        }
      }
      var qs = {
        from: $scope.criteria.from,
        to: $scope.criteria.to,
        invoice_id: $scope.criteria.invoice_id.join(','),
      }

      var thisRequest = ++request

      //$location.search('period',     $scope.criteria.period);
      $location.search(qs)
      $scope.report = {}
      Invoice.report({criteria: $scope.criteria}, function (report) {
        // a clumsy way to only show the results of the latest query (if the results come out of order)
        if (thisRequest === request) {
          $scope.report = report
          $scope.downloadUrl = CONFIG.url.invoices.download_report() + '?' + $.param(qs)
        }
      })
    }

    $scope.downloadRefs = function (period) {
      location.href = CONFIG.url.invoices.download_refs() + '?' + jQuery.param({period: period})
    }

    $scope.loadReport()
  }])

  angular
    .module('invoices')
    .controller('SalesInvoiceListCtrl', ['$scope', '$routeParams', '$location', 'Invoice', '$modal', function ($scope, $routeParams, $location, Invoice, $modal) {
      $scope.utils.setPageID('invoices')
      $scope.utils.setPageTitle(_('invoice_sales_invoice_list'))
      $scope.reportView = 'sales_invoice_list'

      var now = new Date()
      var today = now.toISOString().split('T')[0]
      $scope.criteria = {
        from: $routeParams.from || '' + now.getFullYear() + '-01-01',
        to: $routeParams.to || today,
      }
      $scope.maxDate = today

      $scope.showCreditReceipt = function (iinumber) {
        openCreditReceiptModal(iinumber, Invoice, $modal, $scope)
      }

      $scope.paginate = function (page) {
        $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
      }

      $scope.loadSalesInvoiceList = function () {
        var qs = {
          from: $scope.criteria.from,
          to: $scope.criteria.to,
        }
        $location.search(qs)
        $scope.report = {}

        Invoice.sales_invoice_list({criteria: $scope.criteria}, function (report) {
          $scope.report = report
          $scope.salesInvoiceListDownloadUrlXLS = CONFIG.url.invoices.sales_invoice_list_xls() + '?' + $.param(qs)
          $scope.salesInvoiceListDownloadUrlPDF = CONFIG.url.invoices.sales_invoice_list_pdf() + '?' + $.param(qs)
          // Pagination
          if ($scope.report.rows) {
            $scope.pageSize = 100
            $scope.numberOfPages = Math.ceil($scope.report.rows.length / $scope.pageSize)
            $scope.currentPage = 0
          }
        })
      }

      $scope.loadSalesInvoiceList()

      a4.loaded($scope)
    }])

  angular.module('invoices').controller('AccountsReceivableCtrl', ['$scope', '$routeParams', '$location', 'Invoice', function ($scope, $routeParams, $location, Invoice) {
    $scope.utils.setPageID('invoices')
    $scope.utils.setPageTitle(_('invoice_accounts_receivable'))
    $scope.reportView = 'accounts_receivable'

    var now = new Date()
    $scope.criteria = {
      to: $routeParams.to || '' + new Date().toISOString().split('T')[0],
    }

    $scope.paginate = function (page) {
      $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
    }

    $scope.loadAccountsReceivable = function () {
      var qs = {
        to: $scope.criteria.to,
      }
      $location.search(qs)
      $scope.report = {}
      Invoice.accounts_receivable({criteria: $scope.criteria}, function (report) {
        $scope.report = report
        $scope.accountsReceivableDownloadUrlXLS = CONFIG.url.invoices.accounts_receivable_xls() + '?' + $.param(qs)
        $scope.accountsReceivableDownloadUrlPDF = CONFIG.url.invoices.accounts_receivable_pdf() + '?' + $.param(qs)
        // Pagination
        $scope.pageSize = 100
        $scope.numberOfPages = Math.ceil($scope.report.rows.length / $scope.pageSize)
        $scope.currentPage = 0
      })
    }

    $scope.loadAccountsReceivable()

    a4.loaded($scope)
  }])

  angular
    .module('invoices')
    .controller(
      'InvoiceAddCtrl',
      ['$rootScope', '$scope', '$route', '$timeout', '$routeParams', '$location', 'Invoice', 'Settings', '$compile', function ($rootScope, $scope, $route, $timeout, $routeParams, $location, Invoice, Settings, $compile) {
        a4.checkStrongholdNotification($rootScope, $scope, $location, $compile)

        $scope._sending = false
        $scope.previewing = false

        var isReminder = $route.current.$$route.reminder
        var addRecips = $route.current.$$route.addrecips
        var defaultInvoice
        var pageTitle

        if (isReminder) {
          pageTitle = _('invoicereminder_create_new_invoice')
        } else if (addRecips) {
          pageTitle = _('invoice_add_recips')
        } else {
          pageTitle = _('invoice_create_new_invoice')
        }

        $scope.utils.setPageTitle(pageTitle)
        $scope.utils.setPageID('invoices')

        Settings.get({}, function (settings) {
          $scope.settings = settings
          if (isReminder || addRecips) {
            // IE/placeholder fix
            $scope.subject_placeholder = ''
            $scope.description_placeholder = ''
          } else {
            var now = new Date()
            $scope.subject_placeholder = _('invoice_title_placeholder') + ' ' + now.getFullYear()
            $scope.description_placeholder = _('invoice_description_placeholder')
          }
        })

        var due = new Date()
        due.setHours(12) // avoid DST issues
        due.setTime(due.getTime() + 14 * 86400 * 1000) // add 14 days

        var default_date_due = JSON.stringify(due).substr(1, 10) // hack to output ISO date even for IE8

        $scope.pages = [{num: 1, description: ''}]

        $scope.add_page = function () {
          if ($scope.pages.length < 16) {
            $scope.pages.push({
              num: $scope.pages.length + 1,
              description: '',
            })
          }
        }

        $scope.remove_page = function () {
          if ($scope.pages[$scope.pages.length - 1].description === '' || confirm(_('js_page_remove_confirm'))) {
            $scope.pages.pop()
          }
        }

        const empty_invoice_row = {
          title: '',
          amount_with_vat: '',
          vat_percent: '', // NB: not 0 so that the dropdown is not pre-selected
        }

        $scope.add_invoice_row = function () {
          if ($scope.msg.invoice_rows_.length >= 8) {
            alert(_('invoice_max_rows'))
            return
          }

          if ($scope.msg.invoice_rows_.length === 1) {
            $scope.msg.subject = $scope.msg.invoice_rows_[0].title
            $scope.msg.invoice_rows_[0].title = ''
          }
          $scope.msg.invoice_rows_.push(angular.copy(empty_invoice_row))

          window.requestAnimationFrame(() => {
            const rowTitleFields = Array.from(document.querySelectorAll('.invoiceRowTable input[name="rowtitle"]'))
            if (!rowTitleFields.length) return

            // When the 2nd row is added, focus on the *1st* row's title field, since it is empty.
            // Otherwise focus on the *last* row's title field.
            const newRowTitleField = rowTitleFields.length > 2 ? rowTitleFields.reverse()[0] : rowTitleFields[0]
            newRowTitleField.focus()
          })
        }

        $scope.remove_invoice_row = function (index) {
          if ($scope.msg.invoice_rows_.length > 1) {
            $scope.msg.invoice_rows_.splice(index, 1)
          }
          // When only one row is left, set its title to the invoice subject
          if ($scope.msg.invoice_rows_.length === 1) {
            $scope.msg.invoice_rows_[0].title = $scope.msg.subject
          }
        }

        $scope.getRowErrors = function (row_index, field) {
          return $scope.errors && $scope.errors[`r${row_index}:${field}`]
        }

        $scope.tax_percentages = SUPPORTED_VAT_PERCENTAGES

        // TMP! Set recipient for testing
        // var condwatcher1 = $scope.$watch('conditions+msg', function () {
        //   if ($scope.conditions.length > 0 && $scope.msg) {
        //     condwatcher1() // unwatch
        //     $scope.conditions.push({
        //       field: 'email',
        //       id: 'foo',
        //       value: window.location.hostname.startsWith('jpya') ? 'veron' : 'salo@avoine',
        //       verb: 'icontains',
        //     })
        //   }
        // })

        if (isReminder || addRecips) {
          Invoice.get(
            {id: $routeParams.id, get_details: false},
            function (data) {
              $scope.msg = data
              var pages = $scope.msg.description.split(a4.letterPageSeparator())
              if (isReminder) {
                $scope.msg.reminder_to_ = $routeParams.id
                if ($scope.msg.invoice_rows_.length === 1) {
                  $scope.msg.invoice_rows_[0].title =
                    _('invoice_reminder_subject_prefix') + $scope.msg.invoice_rows_[0].title
                } else {
                  $scope.msg.subject = _('invoice_reminder_subject_prefix') + $scope.msg.subject
                }
                $scope.msg.date_due = _('invoice_reminder_same_due_as_orig')
                $scope.pages[0].description = pages[0]
              } else {
                // addRecips
                var addRecipsDisabledCode = false
                if (data.is_legacy) {
                  addRecipsDisabledCode = 'invoice_addrecips_not_available_for_legacy_invoices'
                } else if (
                  // vat_obliged_checked is a -1 (legacy) or 0 or 1, but $scope.settings.vat_obliged is boolean
                  !!data.vat_obliged_checked !== !!$scope.settings.vat_obliged
                ) {
                  addRecipsDisabledCode = 'invoice_addrecips_not_available_vat_obliged_mismatch'
                }
                if (addRecipsDisabledCode) {
                  alert(_(addRecipsDisabledCode))
                  $location.path(CONFIG.url.invoices.view($routeParams.id))
                }
                $scope.msg.addrecips_to_ = $routeParams.id
                $scope.msg.date_due = default_date_due
                $scope.pages = []
                $.each(pages, function (idx, val) {
                  $scope.pages.push({
                    num: idx + 1,
                    description: val,
                  })
                })
                $scope.original_description = $scope.msg.description
              }
              a4.loaded($scope)
            },
            a4.restErrorFactory($scope),
          )

          var condwatcher = $scope.$watch(
            'conditions+msg',
            function () {
              if ($scope.conditions.length > 0 && $scope.msg) {
                condwatcher() // unwatch
                $scope.conditions.push({
                  field: 'invoicestatus',
                  field_option: [$scope.msg.id],
                  value: isReminder ? ['overdue'] : ['notsent'],
                  verb: 'a4invoicestatus',
                  locked: !isReminder,
                  removeLocked: isReminder,
                  fieldLocked: isReminder,
                })
                if (isReminder) {
                  $scope.fields.forEach(function (f) {
                    if (f.name === 'invoicestatus') {
                      f.disabled = 'true'
                    }
                  })
                  // Only leave 'pending' and 'overdue' options
                  $scope.fieldHash.invoicestatus.options = $.grep(
                    $scope.fieldHash.invoicestatus.options,
                    function (opt) {
                      return opt.value === 'pending' || opt.value === 'overdue'
                    },
                  )
                }
              }
            },
            true,
          )
        } else {
          // New blank invoice

          defaultInvoice = new Invoice({
            date_due: default_date_due,
            subject: '',
            amount: '',
            description: '',
            msg_media: 'email',
            invoice_rows_: [angular.copy(empty_invoice_row)],
            // TMP: pre-fill for easy testing
            // subject: 'Jäsenmaksu ' + Math.random(),
            // invoice_rows_: [
            //   {
            //     title: 'Jäsenyys 2023',
            //     amount_with_vat: '14.50',
            //     vat_percent: 0,
            //   },
            //   {
            //     title: 'Pipo',
            //     amount_with_vat: '20',
            //     vat_percent: 25.5,
            //   },
            // ],
            // description:
            //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pretium, lacus in fermentum facilisis, sem lorem interdum urna, vitae dictum sapien dolor eget lacus.',
            // sms_notification_: true,
          })

          $scope.msg = angular.copy(defaultInvoice)
          a4.loaded($scope)
        }

        $scope.resultAmount = 0

        $scope.$watch('msg.msg_media', function () {
          // get rid of the letter separator if the user decides to switch to e.g. sms all of a sudden
          if (
            $scope.msg &&
            $scope.msg.msg_media !== 'letter' &&
            $scope.msg.description &&
            $scope.msg.description.indexOf(a4.letterPageSeparator()) !== -1
          ) {
            $scope.msg.description = a4.stripLetterPageSeparator($scope.msg.description, '\n\n')
          }
          if ($scope.msg && $scope.msg.msg_media === 'letter' && addRecips) {
            $scope.msg.description = $scope.original_description
          }
        })

        $scope.proceed_to_payment = function () {
          var _self = this

          $scope.msg.filter = $scope.filter_to_post

          $scope._sending = true

          Invoice.save(
            {},
            $scope.msg,
            // success handler: get the mooney id and go to mooney.charge
            function (data) {
              _self.invoice_form.$dirty = false
              $location.path(CONFIG.url.mooney.method(data.mid)).search('goto', CONFIG.get('urls.invoices.all'))
              $scope._sending = false
            },
            // error handler
            a4.restErrorFactory($scope),
          )
        }

        $scope.getSendingCount = function () {
          if (!$scope.stats || !$scope.msg) {
            return 0
          }
          return $scope.stats['result_' + $scope.msg.msg_media + '_count']
        }

        $scope.msgModel = function () {
          return isReminder ? 'invoicereminder' : 'invoice'
        }

        $scope.preview = function () {
          const amount = $scope.msg.invoice_rows_.reduce((acc, row) => {
            return acc + parseFloat(row.amount_with_vat)
          }, 0)

          if ($scope.stats && $scope.msg && amount > 0) {
            var resultAmount = amount * $scope.stats['result_' + $scope.msg.msg_media + '_count']
            $scope.resultAmount = a4.formatBigAmount(String(resultAmount.toFixed(2)))
          }

          return a4.msgPreview($scope, Invoice)()
        }

        $scope.cancelPreview = a4.msgPreviewCancel($scope)

        // NB: Identical to the one in announcements.js
        $scope.filterInvalidMembers = function (context) {
          return function (member) {
            var invalidIds = $scope.stats['result_' + context + '_invalid_ids'] || []
            return invalidIds.includes(member.id)
          }
        }

        // NB: This is found on announcements + invoices + updreqs
        $scope.$watch('settings+msg.msg_media', function () {
          if ($scope.settings) {
            $scope.emailMissing = $scope.msg.msg_media === 'email' && $scope.settings.email_missing_
            $scope.vatIdRequired = $scope.msg.msg_media === 'letter' && $scope.settings.vat_id_missing_
            $scope.bankAccountRequired = !$scope.settings.bank_account
          }
        })

        $scope.setTemplate = function (template) {
          $scope.msg.msg_media = template.sending_method
          $scope.msg.subject = template.subject
          $scope.msg.amount = template.amount
          $scope.msg.description = template.description
          $scope.currentTemplate = template.id
        }

        $scope.resetTemplate = function () {
          $scope.msg = angular.copy(defaultInvoice)
          $scope.currentTemplate = null
        }

        $scope.removeTemplate = function (template_id) {
          if (confirm(_('js_template_delete_confirm'))) {
            Invoice.template_remove(
              {template_id: template_id},
              // success handler
              function (data) {
                $scope.templates = data
              },
              a4.restErrorFactory($scope),
            )
          }
        }
      }],
    )

  angular.module('invoices').controller('InvoiceEditCtrl', ['$scope', '$routeParams', '$timeout', 'Invoice', '$modal', function ($scope, $routeParams, $timeout, Invoice, $modal) {
    $scope.working = {}
    $scope.utils.setPageID('invoices')
    $scope.paymentDetails = {}
    $scope.paymentDetailsOpen = {}
    $scope.instanceOutstandingTotal = {}
    $scope.loading = false
    $scope._sending = false
    $scope.add_recips_disabled = false

    getInvoice()

    $scope.paginate = function (page) {
      $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
    }

    $scope.getNumberOfPages = function (msg_count) {
      return Math.ceil(msg_count / $scope.pageSize)
    }

    $scope.showAll = function () {
      $scope.loading = true
      $timeout(function () {
        $scope.currentPage = 0
        $scope.pageSize = 100000
        $scope.numberOfPages = 1
      }, 1)
    }

    // Leave only the latest message status per recipient_address
    // (otherwise there will be too many icons reminders, especially with porgs).
    // Also saves the original first message (the initial invoice) to instance.initial_msg_status,
    // since filterMessages may replace it with a later reminder for the same address.
    function filterMessages(instance) {
      var msg_statuses = instance.msg_statuses
      instance.initial_msg_status = msg_statuses && msg_statuses.length > 0 ? msg_statuses[0] : null
      if (msg_statuses && msg_statuses.length > 0) {
        const latestMessages = new Map()
        msg_statuses.forEach(function (msg) {
          const stored = latestMessages.get(msg.recipient_address)
          // If there's nothing yet for this address, or the current one is later, update the map
          if (!stored || new Date(msg.date_sent) > new Date(stored.date_sent)) {
            latestMessages.set(msg.recipient_address, msg)
          }
        })
        // Convert the map values to an array and assign it back to msg_statuses
        instance.msg_statuses = Array.from(latestMessages.values())
      }
    }

    function getInvoice() {
      Invoice.get(
        {id: $routeParams.id},
        // success handler
        function (data) {
          $scope.msg = data
          $scope.msg.amount_pending_c = (
            $scope.msg.amount_total_c -
            $scope.msg.amount_paid_c -
            $scope.msg.amount_credited_c -
            $scope.msg.amount_cancelled_c
          ).toFixed(2)

          // Happens at least right after PDF generation
          $scope.processing_invoice = !$scope.msg.instances[0].msg_statuses

          $scope.viewStatus = ''
          $scope.utils.setPageTitle($scope.msg.subject + ' - ' + _('breadcrumb_invoices'))

          // pagination
          $scope.pageSize = 20
          $scope.numberOfPages = $scope.getNumberOfPages($scope.msg.instances.length)
          $scope.currentPage = 0

          sortTooltips()

          $scope.statuses = ['paid', 'pending', 'cancelled', 'overpaid', 'underpaid', 'overdue', 'credited']
          $scope.statusstyles = ['success', 'info', 'cancelled', 'overpaid', 'warning', 'danger', 'cancelled']

          var sent_dates = []
          var due_dates = []

          $.each($scope.msg.instances, function (idx, instance) {
            sent_dates[instance.date_sent] = true
            due_dates[instance.date_due] = true
            filterMessages(instance)
          })

          // $.unique because date_sent timestamps can be on different seconds
          $scope.sent_dates = $.unique(
            $.map(Object.keys(sent_dates).sort(), function (d) {
              return _.date(d)
            }),
          )
          $scope.due_dates = $.map(Object.keys(due_dates).sort(), function (d) {
            return _.date(d)
          })

          // Do not allow adding recips to invoices that have VAT percentages not currently supported
          for (var i = 0; i < $scope.msg.invoice_rows_.length; i++) {
            var invoiceRowVatPercent = parseFloat($scope.msg.invoice_rows_[i].vat_percent)
            var isSupportedVatPercent = SUPPORTED_VAT_PERCENTAGES.some(function (vat) {
              return vat.value === invoiceRowVatPercent
            })
            if (!isSupportedVatPercent) {
              $scope.add_recips_disabled = true
              break
            }
          }

          a4.loaded($scope)

          if ($scope.msg.msg_media === 'email' && data.has_queued_msgs) {
            a4.timeout($timeout, $scope, getInvoice, 5000)
          }

          $scope.pages = $scope.msg.description.split(a4.letterPageSeparator())
        },
        a4.restErrorFactory($scope),
      )
    }

    // Near duplicate from announcements controller
    $scope.setViewStatus = function (viewStatus) {
      $scope.viewStatus = viewStatus

      // reset pagination
      $scope.currentPage = 0
      if (viewStatus === '') {
        $scope.numberOfPages = $scope.getNumberOfPages($scope.msg.instances.length)
      } else if (viewStatus === 'person_id') {
        $scope.numberOfPages = 1
      } else if (viewStatus === 'pending') {
        $scope.numberOfPages = $scope.getNumberOfPages($scope.msg.count_open_c)
      } else {
        $scope.numberOfPages = $scope.getNumberOfPages($scope.msg['count_' + viewStatus + '_c'])
      }

      $scope.filterInvoiceStatus = function (thing) {
        if (viewStatus === '') {
          return true
        } else if (viewStatus === 'person_id') {
          return thing.person_id === parseInt($scope.personId)
        } else if (viewStatus === 'pending') {
          return thing.status_c === viewStatus || thing.status_c === 'underpaid'
        } else {
          return thing.status_c === viewStatus
        }
      }

      // This didn't work with pagination so commented it out. Wonder what
      // was the reason for it in the first place?
      // if(!$scope.tableHeight) {
      //   $scope.tableHeight = $('table.mmp-payment-detail').height();
      // }
      // $('table.mmp-payment-detail').parent().css('height', $scope.tableHeight);
    }

    // person_id was given as a second parameter (/r/invoices/12/person/345),
    // let's filter the view to show only the invoice of that person
    if ($routeParams.person_id) {
      $scope.personId = $routeParams.person_id
      $scope.setViewStatus('person_id')
    }

    function sortTooltips() {
      $timeout(function () {
        $(function () {
          $('.progress .tooltip').remove()
          $('.progress > div').each(function () {
            $(this).removeClass('active').tooltip('destroy')
            $(this).attr('data-oldtitle', $(this).attr('title'))
            if ($(this).width() > 0) {
              $(this).addClass('active')
              $(this).tooltip({trigger: 'manual', placement: 'bottom'})
            }
          })
          $('.progress > div.active').tooltip('show')
        })
      }, 800)
    }

    $scope.openCreateCreditInvoiceModal = function (instance) {
      const is_partly_paid = instance.amount_open_c !== $scope.msg.amount

      // find if there are invoice rows with multiple vat percentages
      const has_multi_vat = $scope.msg.invoice_rows_.find(
        (row) => row.vat_percent !== $scope.msg.invoice_rows_[0].vat_percent,
      )
      $scope.modal_data = {
        instance,
        amount_to_credit: instance.amount_open_c, // see below
        comment: '',
        is_partly_paid,
        has_multi_vat,
      }

      if (has_multi_vat && is_partly_paid) {
        $scope.modal_data.amount_to_credit = $scope.msg.invoice_rows_.map((row) => ({
          title: row.title,
          original_amount_with_vat: row.amount_with_vat,
          // if there are no payments to this invoice yet, suggest full amounts for crediting
          credited_amount_with_vat: is_partly_paid ? null : row.amount_with_vat,
          vat_percent: row.vat_percent,
          max: Math.min(row.amount_with_vat, instance.amount_open_c),
        }))
        $scope.modal_data.updateTotal = function () {
          const total_cents = Math.round(
            $scope.modal_data.amount_to_credit
              .map((row) => a4.amountStringToCents(row.credited_amount_with_vat || '0'))
              .reduce((acc, val) => acc + val, 0),
          )
          $scope.modal_data.is_total_valid = total_cents === Math.round(instance.amount_open_c * 100)
          if (Number.isNaN(total_cents)) {
            $scope.modal_data.computed_total = '???'
          } else {
            $scope.modal_data.computed_total = _.amount(total_cents / 100)
          }
        }
        $scope.modal_data.updateTotal()
      }
      _openInvoiceModal('credit', $modal, $scope)
    }

    $scope.submitCreditModal = function (instance_id, action_type, amount, comment) {
      $scope._sending = true
      $scope.addAction(instance_id, action_type, amount, comment, true, () => {
        $scope._sending = false
        $scope.$modal('hide')
      })
    }

    $scope.showCreditReceipt = function (iinumber) {
      openCreditReceiptModal(iinumber, Invoice, $modal, $scope)
    }

    $scope.openManualPaymentModal = function (instance) {
      $scope.modal_data = {
        instance,
        amount: instance.amount_open_c === '0.00' ? '-' + instance.amount_paid_c : instance.amount_open_c,
        comment: '',
        errors: {},
      }
      _openInvoiceModal('manualpayment', $modal, $scope)
    }

    $scope.submitManualPaymentModal = function (instance_id, action_type, amount, comment) {
      $scope._sending = true
      $scope.addAction(instance_id, action_type, amount, comment, true, () => {
        $scope._sending = false
        $scope.$modal('hide')
      })
    }

    $scope.addAction = function (instance_id, action_type, amount, comment, modal = false, onSuccess = null) {
      if (Array.isArray(amount)) {
        amount = JSON.stringify(
          amount.map((r) => {
            if (r.credited_amount_with_vat !== null) {
              return r.credited_amount_with_vat.replace(',', '.')
            } else {
              return '0'
            }
          }),
        )
      }

      // Invalidate any cached details
      delete $scope.paymentDetailsOpen[instance_id]
      delete $scope.paymentDetails[instance_id]

      // Sort out the table row height so it doesn't change when the buttons swap to the loader
      $('#ins-' + instance_id).css('height', $('#ins-' + instance_id).outerHeight(true))

      $scope.working[instance_id] = true

      Invoice.addAction(
        {
          instance_id: instance_id,
          action_type: action_type,
          amount: amount,
          comment: comment,
        },
        // success handler
        function (data) {
          $scope.msg = data
          $.each($scope.msg.instances, function (idx, instance) {
            filterMessages(instance)
          })

          delete $scope.working[instance_id]
          sortTooltips()

          if (typeof onSuccess === 'function') {
            onSuccess()
          }
        },
        // error handler
        function (data) {
          $scope._sending = false
          a4.restErrorFactory($scope.modal_data, instance_id, modal)(data)
        },
      )
    }
    $scope.updateStatusLegacy = function (status, instance_id, extra_fields) {
      // Invaldate any cached details
      delete $scope.paymentDetailsOpen[instance_id]
      delete $scope.paymentDetails[instance_id]

      // Sort out the table row height so it doesn't change when the buttons swap to the loader
      $('#ins-' + instance_id).css('height', $('#ins-' + instance_id).outerHeight(true))

      $scope.working[instance_id] = true

      Invoice.updateStatusLegacy(
        {
          instance_id: instance_id,
          status: status,
          extra_fields: extra_fields,
        },
        // success handler
        function (data) {
          $scope.msg = data

          delete $scope.working[instance_id]
          sortTooltips()
        },
        // error handler
        a4.restErrorFactory($scope, instance_id),
      )
    }

    $scope.addFakeBankRow = function (instance_id, reference_number) {
      const userInput = prompt(_('invoice_give_amount_for_fake_bank_row'))

      if (!userInput || !/^-?\d+([.,]\d\d?)?$/.test(userInput)) {
        alert('Tarkista summa.')
        return
      }
      const amount = parseFloat(userInput.replace(',', '.')).toFixed(2)

      Invoice.addFakeBankRow(
        {
          instance_id: instance_id,
          reference_number: reference_number,
          amount: amount,
        },
        // success handler
        function (data) {
          // This function is only available for customer support,
          // so we can just reload the page.
          window.location.reload()
        },
        // error handler
        a4.restErrorFactory($scope, instance_id),
      )
    }

    $scope.showInstanceEventsLegacy = function (instance_id) {
      if ($scope.paymentDetailsOpen[instance_id]) {
        delete $scope.paymentDetailsOpen[instance_id]
      } else {
        $scope.paymentDetailsOpen[instance_id] = true
      }

      if (!$scope.paymentDetails[instance_id]) {
        Invoice.getInstanceEventsLegacy(
          {
            instance_id: instance_id,
          },
          function (data) {
            $scope.paymentDetails[instance_id] = data.results
            $scope.instanceOutstandingTotal[instance_id] = 0

            // Keep track of the paid amount so that we know how much "mark_paid" should
            // be to when it happens. This is important at least when someone pays
            // via bank syncing something but not the total amount. zd:195975
            let paid = 0

            for (var i = 0; i < $scope.paymentDetails[instance_id].length; i++) {
              var row = $scope.paymentDetails[instance_id][i]

              paid += parseFloat(row.amount)

              if (row.action_type === 'mark_paid') {
                row.amount = parseFloat($scope.msg.amount - paid).toFixed(2)

                // If this instance only has two actual events (mark_paid and sync_payment),
                // user can cancel the mark_paid event. https://trello.com/c/SdAWeMmF
                row.cancellable = false

                // Filter out items that should not be considered.
                const filteredItems = $scope.paymentDetails[instance_id].filter(
                  (item) => item.action_type !== 'reminder',
                )
                if (filteredItems.length === 2) {
                  const actionTypes = filteredItems.map((item) => item.action_type)
                  if (actionTypes.includes('mark_paid') && actionTypes.includes('sync_payment')) {
                    row.cancellable = true
                  }
                }
              } else if (row.action_type === 'mark_pending' || row.action_type === 'mark_paid_cancel') {
                row.amount = parseFloat(-$scope.msg.amount).toFixed(2)
              } else if (row.action_type === 'mark_cancelled') {
                row.amount = $scope.msg.amount
              }
              // At least 'Member was sent a reminder' are rows that do not have an amount.
              if (typeof row.amount !== 'undefined') {
                $scope.instanceOutstandingTotal[instance_id] += parseFloat(row.amount)
              }
            }

            $scope.instanceOutstandingTotal[instance_id] -= $scope.msg.amount
          },
          a4.restErrorFactory($scope, instance_id),
        )
      }
    }
    $scope.showInstanceEvents = function (instance_id) {
      if ($scope.paymentDetailsOpen[instance_id]) {
        delete $scope.paymentDetailsOpen[instance_id]
      } else {
        $scope.paymentDetailsOpen[instance_id] = true
      }

      if (!$scope.paymentDetails[instance_id]) {
        Invoice.getInstanceEvents(
          {
            instance_id: instance_id,
          },
          function (data) {
            $scope.paymentDetails[instance_id] = data.results
            $scope.instanceOutstandingTotal[instance_id] = 0

            // Keep track of the paid amount so that we know how much "mark_paid" should
            // be to when it happens. This is important at least when someone pays
            // via bank syncing something but not the total amount. zd:195975
            let paid = 0

            for (var i = 0; i < $scope.paymentDetails[instance_id].length; i++) {
              var row = $scope.paymentDetails[instance_id][i]

              paid += parseFloat(row.amount)

              if (row.action_type === 'mark_paid') {
                row.amount = parseFloat($scope.msg.amount - paid).toFixed(2)

                // If this instance only has two actual events (mark_paid and sync_payment),
                // user can cancel the mark_paid event. https://trello.com/c/SdAWeMmF
                row.cancellable = false

                // Filter out items that should not be considered.
                const filteredItems = $scope.paymentDetails[instance_id].filter(
                  (item) => item.action_type !== 'reminder',
                )
                if (filteredItems.length === 2) {
                  const actionTypes = filteredItems.map((item) => item.action_type)
                  if (actionTypes.includes('mark_paid') && actionTypes.includes('sync_payment')) {
                    row.cancellable = true
                  }
                }
              } else if (row.action_type === 'mark_pending' || row.action_type === 'mark_paid_cancel') {
                row.amount = parseFloat(-$scope.msg.amount).toFixed(2)
              } else if (row.action_type === 'mark_cancelled') {
                row.amount = $scope.msg.amount
              }
              // At least 'Member was sent a reminder' are rows that do not have an amount.
              if (typeof row.amount !== 'undefined') {
                $scope.instanceOutstandingTotal[instance_id] += parseFloat(row.amount)
              }
            }

            $scope.instanceOutstandingTotal[instance_id] -= $scope.msg.amount
          },
          a4.restErrorFactory($scope, instance_id),
        )
      }
    }
  }])
})()
